import { render, staticRenderFns } from "./properties-block-text-and-image.vue?vue&type=template&id=115c8e97&scoped=true"
import script from "./properties-block-text-and-image.vue?vue&type=script&lang=js"
export * from "./properties-block-text-and-image.vue?vue&type=script&lang=js"
import style0 from "./properties-block-text-and-image.vue?vue&type=style&index=0&id=115c8e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c8e97",
  null
  
)

export default component.exports